import React, { useEffect, useState } from "react";
import { Col, Row, Table } from "reactstrap";

export const BillContent = ({
  currentOrder,
  totalDiscount,
  netAmount,
  responseData,
  printBillData,
  apiOrderedItems,
  storeDiscount,
  discountAmount,
}) => {
  console.log("🚀 ~ BillContent ~ discountAmount:", discountAmount);

  if (!apiOrderedItems.length) {
    return <div>No items available</div>;
  }

  const { taxAmount, itemAmount, finalAmount, taxPercentage } =
    apiOrderedItems[0];

  const totalNetAmount = itemAmount + taxAmount - (discountAmount || 0);
  const [userInfo, setUserInfo] = useState(null);
  useEffect(() => {
    const storedUserInfo = localStorage.getItem("user");
    if (storedUserInfo) {
      const parsedUserInfo = JSON.parse(storedUserInfo);
      setUserInfo(parsedUserInfo);
    }
  }, []);

  return (
    <div id="bill-content">
      <div className="text-center">
        {userInfo && (
          <>
            <h4 className="m-0 p-0">{userInfo.organizationInfo.name}</h4>
            <p className="m-0 p-0">{userInfo.organizationInfo.address1}</p>
            <p className="m-0 p-0">Phone: {userInfo.organizationInfo.tel}</p>
          </>
        )}
      </div>
      <div>
        <h6>Invoice Number: {responseData?.invoiceNumber}</h6>
      </div>
      <Table bordered size="sm" className="mb-3 mt-2">
        <thead>
          <tr className="bg-light">
            <th className="text-center" width="10%">
              S.N
            </th>
            <th width="30%">Item</th>
            <th className="text-end" width="15%">
              Qty
            </th>
            <th className="text-end" width="20%">
              Price
            </th>
            <th className="text-end" width="25%">
              Total
            </th>
          </tr>
        </thead>
        <tbody>
          {currentOrder.map((item, index) => (
            <tr key={item.id}>
              <td className="text-center">{index + 1}</td>
              <td>{item.title}</td>
              <td className="text-end">
                {item.quantity + item?.complimentryQuantity}
              </td>
              <td className="text-end">Rs. {item.price}</td>
              <td className="text-end">
                Rs. {(item.quantity * item.price).toFixed(2)}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <Row className="">
        <Col xs={12}>
          <Row className="mb-2">
            <Col xs={9} className="text-end">
              Sub Total:
            </Col>
            <Col xs={3} className="text-end">
              Rs. {itemAmount.toFixed(2)}
            </Col>
          </Row>
          <Row className="mb-2">
            <Col xs={9} className="text-end">
              Discount (%):
            </Col>
            <Col xs={3} className="text-end">
              {printBillData?.addDiscount}
            </Col>
          </Row>
          {taxAmount !== 0 && (
            <Row className="mb-2">
              <Col xs={9} className="text-end">
                VAT ({taxPercentage}%):
              </Col>
              <Col xs={3} className="text-end">
                Rs. {taxAmount}
              </Col>
            </Row>
          )}
          {/* {serviceCharge !== 0 && (
            <Row className="mb-2">
              <Col xs={9} className="text-end">
                Service Charge:
              </Col>
              <Col xs={3} className="text-end">
                Rs. {serviceCharge}
              </Col>
            </Row>
          )} */}
          {/* <hr /> */}
          <Row className="fw-bold">
            <Col xs={9} className="text-end">
              Net Amount:
            </Col>
            <Col xs={3} className="text-end">
              Rs. {totalNetAmount?.toFixed(2)}
            </Col>
          </Row>
        </Col>
      </Row>
      <div className="text-center mt-3">
        <p className="p-0 m-0">Thank You!</p>
        <p className="p-0 m-0">Visit Us Again!!!</p>
      </div>
    </div>
  );
};

// import React, { useEffect, useState } from "react";
// import { Col, Row, Table } from "reactstrap";

// // Creating BillContent as a forwardRef component
// export const BillContent = React.forwardRef(({
//   currentOrder,
//   totalAmountBeforeDiscount,
//   totalDiscount,
//   netAmount,
//   serviceCharge,
//   taxAmount,
// }, ref) => {
//   const [userInfo, setUserInfo] = useState(null);

//   useEffect(() => {
//     const storedUserInfo = localStorage.getItem("user");
//     if (storedUserInfo) {
//       const parsedUserInfo = JSON.parse(storedUserInfo);
//       setUserInfo(parsedUserInfo);
//     }
//   }, []);

//   return (
//     <div id="bill-content" ref={ref}>
//       <div className="text-center">
//         {userInfo && (
//           <>
//             <h4 className="m-0 p-0">{userInfo.organizationInfo.name}</h4>
//             <p className="m-0 p-0">{userInfo.organizationInfo.address1}</p>
//             <p className="m-0 p-0">Phone: {userInfo.user.phoneNumber}</p>
//           </>
//         )}
//       </div>
//       <Table bordered size="sm" className="mb-3 mt-2">
//         <thead>
//           <tr className="bg-light">
//             <th className="text-center" width="10%">
//               S.N
//             </th>
//             <th width="30%">Item</th>
//             <th className="text-end" width="15%">
//               Qty
//             </th>
//             <th className="text-end" width="20%">
//               Price
//             </th>
//             <th className="text-end" width="25%">
//               Total
//             </th>
//           </tr>
//         </thead>
//         <tbody>
//           {currentOrder.map((item, index) => (
//             <tr key={item.id}>
//               <td className="text-center">{index + 1}</td>
//               <td>{item.title}</td>
//               <td className="text-end">{item.quantity}</td>
//               <td className="text-end">Rs. {item.price}</td>
//               <td className="text-end">
//                 Rs. {(item.quantity * item.price).toFixed(2)}
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </Table>
//       <Row className="">
//         <Col xs={12}>
//           <Row className="mb-2">
//             <Col xs={9} className="text-end">
//               Sub Total:
//             </Col>
//             <Col xs={3} className="text-end">
//               Rs. {Number(totalAmountBeforeDiscount).toFixed(2)}
//             </Col>
//           </Row>
//           <Row className="mb-2">
//             <Col xs={9} className="text-end">
//               Discount:
//             </Col>
//             <Col xs={3} className="text-end">
//               Rs. {totalDiscount.toFixed(2)}
//             </Col>
//           </Row>
//           <Row className="mb-2">
//             <Col xs={9} className="text-end">
//               VAT (%):
//             </Col>
//             <Col xs={3} className="text-end">
//               Rs. {taxAmount}
//             </Col>
//           </Row>
//           <Row className="mb-2">
//             <Col xs={9} className="text-end">
//               Service Charge:
//             </Col>
//             <Col xs={3} className="text-end">
//              Rs. {serviceCharge}
//             </Col>
//           </Row>
//           <hr />
//           <Row className="fw-bold">
//             <Col xs={9} className="text-end">
//               Net Amount:
//             </Col>
//             <Col xs={3} className="text-end">
//               Rs. {Number(netAmount).toFixed(2)}
//             </Col>
//           </Row>
//         </Col>
//       </Row>
//       <div className="text-center mt-3">
//         <p className="p-0 m-0">Thank You!</p>
//         <p className="p-0 m-0">Visit Us Again!!!</p>
//       </div>
//     </div>
//   );
// });
